<template>
  <v-dialog
    scrollable
    max-width="500"
    v-model="show"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card>
      <v-card-title>
        {{ $t('common.debug') }}
      </v-card-title>

      <v-card-text>
        <template v-for="(value, key) in item" v-key="property">
          <ul v-bind:key="key">
            <li class="mb-2">
              <strong>{{ key }}: </strong>
              <span>
                <span v-if="typeof value === 'object'">
                  <div v-for="(v, k) in value" class="ml-16" v-bind:key="k">
                    <strong>{{ k }}: </strong>
                    <span class="word-break">{{ v }}</span>
                  </div>
                </span>
                <span v-else>{{ value }}</span>
              </span>
            </li>
          </ul>
        </template>
      </v-card-text>
      <v-card-actions class="justify-end">
        <Button
          color="primary"
          :text="$t('common.button.ok')"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'DebugModal',
  components: {
    Button,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },

    item: {
      type: Object,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.word-break {
  word-break: break-all;
}
</style>
